import * as React from "react";
import Head from "next/head";
import Footer from "../components/Footer";
import Layout from "../components/Layout";
import Header from "../components/Header";
import Testimonials from "../components/Testimonials";

export default function IndexRoute() {
  return (
    <>
        <Head>
            <title>TacBoard Testimonials</title>
            <meta name="description" content="Event guests love using TacBoard's Live Photo Stream. The experience is fun, interactive, and effortless. No app to download." />
            <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Aleo:200,300,400,700|Montserrat:300,400,500,700" />
                <link rel="canonical" href="https://tacboard.com/testimonials" />
        </Head>

      <Layout classes={["testp", "public"]}>
        <Header />
        <Testimonials />
        <Footer />
      </Layout>
    </>
  );
};
